@if (bu) {
  <span class="bu-badge"
        [style.background]="bu.bg"
        [style.color]="bu.color"
        [style.borderColor]="bu.ring"
        [title]="bu.name">{{ bu.key }}</span>
} @else {
  <span class="muted-dash">—</span>
}
